import { render } from "./submission-tab-invest-range.vue?vue&type=template&id=061211c7&scoped=true&ts=true"
import script from "./submission-tab-invest-range.vue?vue&type=script&lang=ts"
export * from "./submission-tab-invest-range.vue?vue&type=script&lang=ts"

import "./submission-tab-invest-range.vue?vue&type=style&index=0&id=061211c7&lang=scss&scoped=true"
import "./submission-tab-invest-range.vue?vue&type=style&index=1&id=061211c7&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061211c7"]])

export default __exports__